export default __webpack_public_path__ + "static/media/calendar-date.c93eef27.svg";